import BreedAPI from "@/app/apis/main/breed/breed-api.js"

export default {
	/**
	 * @returns {object} breed list
	 */
	async getBreeds() {
		return BreedAPI.getBreeds()
	},

	/**
	 * @return {object} breeds info for general, health, exercise
	 */
	async getBreedInfo(breedId) {
		return BreedAPI.getBreedInfo(breedId)
	},

	/**
	 * @return {object} breed info for health alerts notification
	 */
	async getBreedInfoByID(infoId) {
		return BreedAPI.getBreedInfoByID(infoId)
	},

	/**
	 * @returns {object} breeder list
	 */
	async getBreeders(queryParams) {
		return BreedAPI.getBreeders(queryParams)
	},

	async getBreedsBySize(breedSizeId) {
		return BreedAPI.getBreedsBySize(breedSizeId)
	},
}
